import React, { useCallback, useEffect, useState } from 'react';
import Grid from '@mui/material/Grid2';
import StatusFormatter from '../SmartTable/StatusFormatter';
import { getAgentTaskRouteRequest } from '@core/api/agents/agents.service';
import MapStaticComponent from '~/MapStatic/MapStatic.component';
import StaticMarker from '~/MapStatic/components/StaticMarker';
import StaticRoute from '~/MapStatic/components/StaticRoute';
import { useDispatch } from 'react-redux';
import {
  SmartTaskRouteContainer,
  SmartTaskRouteLabel,
  SmartTaskRouteInput,
  SmartTaskRouteNote,
} from '~/FielderElements/SmartTaskTable/SmartStyles';

const LabelText = ({ label, text }) => (
  <Grid size={12} sx={{ my: 1.5 }}>
    <SmartTaskRouteLabel>{label}</SmartTaskRouteLabel>
    <SmartTaskRouteInput
      value={text ?? ''}
      disabled
      fullWidth
      size="small"
      variant="outlined"
      InputProps={{ readOnly: true }}
    />
  </Grid>
);
const TaskRoute = (props) => {
  const { lan, taskData, taskAgent, idTask, idAgent, changeLoadingState } = props;
  const dispatch = useDispatch();
  const [agentStartLocation, setAgentStartLocation] = useState(null);
  const [agentRoute, setAgentRoute] = useState([]);
  const loadAgentRoute = useCallback(() => {
    if (!taskAgent || !idTask) return;
    changeLoadingState && changeLoadingState();
    const body = {
      idTask,
      idAgent: idAgent || taskAgent.idAgent,
    };
    const onSuccess = ({ taskRoute }) => {
      let startLocation = null;
      const routePoints = [];

      if (taskRoute) {
        taskRoute.forEach((location, index) => {
          if (index === 0) {
            startLocation = {
              coordinates: {
                lat: location.latitude,
                lng: location.longitud,
              },
            };
          }

          routePoints.push([
            {
              lat: location.latitude,
              lng: location.longitud,
            },
          ]);
        });
      }

      if (taskData?.coords) {
        routePoints.push(taskData.coords);
      }

      setAgentStartLocation(startLocation);
      setAgentRoute(routePoints);
    };

    const loadingConfig = { dispatch };

    getAgentTaskRouteRequest(body, onSuccess, null, loadingConfig).finally(() => {
      changeLoadingState && changeLoadingState();
    });
  }, [changeLoadingState, dispatch, idTask, idAgent, taskAgent, taskData?.coords]);
  useEffect(() => {
    if (taskData?.idFielder) {
      loadAgentRoute();
    }
  }, [loadAgentRoute, taskData?.idFielder]);
  if (!taskData) return null;
  return (
    <SmartTaskRouteContainer>
      <Grid container spacing={2}>
        {/* Left column: id, status, note */}
        <Grid size={{ xs: 12, md: 4 }}>
          <Grid container>
            <Grid size={12}>
              <LabelText
                label={lan.idCustom}
                text={taskData.number}
              />
            </Grid>
            <Grid size={12}>
              <StatusFormatter {...props} value={taskData.status} />
            </Grid>
            {taskData.offlineExecution && (
              <Grid size={12}>
                <SmartTaskRouteNote>{lan.routeNote}</SmartTaskRouteNote>
              </Grid>
            )}
          </Grid>
        </Grid>
        {/* Right column: map + address */}
        <Grid size={{ xs: 12, md: 8 }} container>
          <Grid size={12} container direction="row" sx={{ justifyContent: "center", alignItems: "center", }}>
            <MapStaticComponent size="800x500">
              {taskData.coords && (
                <StaticMarker
                  location={taskData.coords}
                  icon={taskData.taskPin}
                />
              )}
              {agentStartLocation && taskData.agent && (
                <StaticMarker
                  location={agentStartLocation.coordinates}
                  icon={taskData.agent.pinIcon}
                />
              )}
              <StaticRoute points={agentRoute} color="purple" />
            </MapStaticComponent>
          </Grid>
          <Grid size={12}>
            <LabelText
              label={lan.addressTask}
              text={taskData.address}
            />
          </Grid>
        </Grid>
      </Grid>
    </SmartTaskRouteContainer>
  );
};
export default TaskRoute;
//Original code:
/*import React, { Component } from 'react';
import Grid from '@mui/material/Grid2'
import StatusFormatter from '../SmartTable/StatusFormatter';
import { getAgentTaskRouteRequest } from '@core/api/agents/agents.service';
import { connect } from 'react-redux';
import MapStaticComponent from '~/MapStatic/MapStatic.component';
import StaticMarker from '~/MapStatic/components/StaticMarker';
import StaticRoute from '~/MapStatic/components/StaticRoute';
class TaskRoute extends Component {
	constructor(props) {
		super(props);
		this.state = {
			agentStartLocation: null,
			agentRoute: [],
		};
	}
	componentDidMount = () => this.getAgentRoute();
	componentDidUpdate = (prevProps) => {
		if (prevProps.taskData.idFielder !== this.props.taskData.idFielder) {
			this.getAgentRoute();
		}
	};
	getAgentRoute = () => {
		this.props.changeLoadingState();
		if (this.props.taskAgent && this.props.idTask) {
			const body = {
				idTask: this.props.idTask,
				idAgent: this.props.idAgent ? this.props.idAgent : this.props.taskAgent.idAgent,
			};

			const onSuccess = ({ taskRoute }) => {
				let agentStartLocation;
				const agentRoute = [];

				if (taskRoute) {
					taskRoute.forEach((location, index) => {
						if (index === 0) {
							agentStartLocation = {
								coordinates: {
									lat: location.latitude,
									lng: location.longitud,
								},
							};
						}

						agentRoute.push([
							{
								lat: location.latitude,
								lng: location.longitud,
							},
						]);
					});
				}

				if (this.props.taskData.coords) {
					agentRoute.push(this.props.taskData.coords);
				}

				this.setState({ agentStartLocation, agentRoute });
			};

			const loadingConfig = {
				dispatch: this.props.dispatch,
			};

			getAgentTaskRouteRequest(body, onSuccess, null, loadingConfig).then(() => {
				this.props.changeLoadingState();
			});
		}
	};
	LabelText = (props) => {
		var text = props.text;
		return (
			<Grid size={12} className={props.className}>
				<Grid className='my-2'>
					<Grid className={'td-label-input ' + props.labelClass}>{props.label}</Grid>
				</Grid>
				<Grid>
					<Grid className={'td-default-text align-left ' + props.textClass}>
						<input
							type='text'
							className={'task-details-input '}
							defaultValue={text}
							disabled={!this.state.editable}
							style={{ width: '100%' }}
						/>
					</Grid>
				</Grid>
			</Grid>
		);
	};
	render() {
		return (
			<Grid className='container' style={{ height: '450px' }}>
        <Grid container spacing={2}>
          <Grid size={4}>
            <Grid container>
              <Grid size={12}>
                <this.LabelText
                  label={this.props.lan.idCustom}
                  text={this.props.taskData.number}
                  className='my-3'
                  textClass='td-task-number'
                />
              </Grid>
              <Grid size={12}>
                <StatusFormatter {...this.props} value={this.props.taskData.status} />
              </Grid>
              {this.props.taskData.offlineExecution && (
                <Grid size={12}>
                  <span style={{ color: '#dc5c87' }}>{this.props.lan.routeNote}</span>
                </Grid>
              )}
            </Grid>
          </Grid>
          <Grid size={8} container>
            <Grid size={12}>
              <MapStaticComponent size='800x500'>
                {this.props.taskData.coords && (
                  <StaticMarker location={this.props.taskData.coords} icon={this.props.taskData.taskPin} />
                )}

                {this.state.agentStartLocation && this.props.taskData.agent && (
                  <StaticMarker
                    location={this.state.agentStartLocation.coordinates}
                    icon={this.props.taskData.agent.pinIcon}
                  />
                )}
                <StaticRoute points={this.state.agentRoute} color='purple' />
              </MapStaticComponent>
            </Grid>
            <Grid size={12}>
              <this.LabelText
                label={this.props.lan.addressTask}
                text={this.props.taskData.address}
                className='my-3'
              />
            </Grid>
          </Grid>
        </Grid>
			</Grid>
		);
	}
}
export default connect()(TaskRoute);
*/
